import axios from 'axios';

const SERVER_URL = process.env.NODE_ENV == 'development' ? 'http://localhost:3000/' : 'https://useit.orlose.it/';
// const SERVER_URL = 'http://localhost:3000/';

export function fetchData(endpoint) {

    //console.log('endpoint',endpoint);

    return new Promise((resolve, reject) => {
        axios.get(SERVER_URL + endpoint)
            .then((response) => {
                if (response.data) {
                    resolve(response.data);
                }
            })
            .then((error) => {
                if (error) reject(error)
            })
    })
}



// WEBPACK FOOTER //
// ./client/api.js